export default __webpack_public_path__ + "static/media/24.221faf27.jpg";